import React from 'react';

import { StateObjMultiple } from '@utils/stateObj.ts';

import AriaAnnouncements from './ariaAnnouncements.tsx';

function create(app) {
  const widgetState = new StateObjMultiple({
    announcements: {},
  });

  widgetState.addCallback(() => app.bus.send('layers/rerender')); // New pattern! Triggers layer manager to rerender when state changes

  app.bus.on('ariaAnnouncer/registerNamespace', ({ announcementKey }) => {
    const currentAnnouncements = widgetState.getState().announcements;
    const updatedAnnouncements = {
      ...currentAnnouncements,
      [announcementKey]: 'default text', // Placeholder to be replaced on announce
    };
    widgetState.update({ announcements: updatedAnnouncements });
  });

  app.bus.on('ariaAnnouncer/announce', ({ announcementKey, announcementText }) => {
    const currentAnnouncements = widgetState.getState().announcements;
    const updatedAnnouncements = {
      ...currentAnnouncements,
      [announcementKey]: announcementText,
    };
    widgetState.update({ announcements: updatedAnnouncements });
  });

  const init = () => {
    app.bus.send('layers/register', {
      id: 'ariaAnnouncements',
      widget: () => <AriaAnnouncements announcements={widgetState.getState().announcements} />,
      isOverlay: true,
      layoutId: 'ariaAnnouncements',
      show: true,
    });
  };
  return {
    init,
  };
}
export { create };
